import {
  LDReactContext,
  type LDReactClient,
  type LDReactClientContextValue,
} from '@launchdarkly/react-sdk';
import { useContext } from 'react';

// The default context value is null, and useLDClient throws when it reads that.
export function useOptionalLDClient(): LDReactClient | undefined {
  const value = useContext(LDReactContext) as
    | LDReactClientContextValue
    | null
    | undefined;
  return value?.client;
}
